import type { CSSProperties } from 'react'

// Stagger helper for elements marked with data-reveal.
export const revealDelay = (ms: number): CSSProperties => ({ '--reveal-delay': `${ms}ms` } as CSSProperties)

// Delay for the on-load .hero-rise animation.
export const riseDelay = (ms: number): CSSProperties => ({ '--rise-delay': `${ms}ms` } as CSSProperties)
